import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useState } from 'react';
import { useGetStressAssessmentAnswers } from './useGetStressAssessmentAnswers';
import { useGetStressAssessmentCategories } from './useGetStressAssessmentCategories';
import { useGetStressAssessmentResult } from './useGetStressAssessmentResult';

type UseStressAssessmentUserDataReturn = {
  result: NonNullable<ReturnType<typeof useGetStressAssessmentResult>['data']>;
  answers: NonNullable<ReturnType<typeof useGetStressAssessmentAnswers>['data']>;
  categories: NonNullable<ReturnType<typeof useGetStressAssessmentCategories>['data']>;
  selectedTab: string;
  handleTabChange: (value: string) => void;
};

export const useStressAssessmentUserResult = (
  stressAssessmentId: number,
  userId: number
): UseStressAssessmentUserDataReturn => {
  const [selectedTab, setSelectedTab] = useState<string>('assessment');

  const handleTabChange = (value: string) => {
    setSelectedTab(value);
  };
  const threeLetterCode = getThreeLetterCode();

  const { data: resultData } = useGetStressAssessmentResult(
    threeLetterCode,
    stressAssessmentId,
    userId,
    {
      swr: {
        suspense: true,
      },
    }
  );

  const userIdFromResult = resultData!.stress_assessment_result.user_id;

  const { data: answersData } = useGetStressAssessmentAnswers(
    threeLetterCode,
    stressAssessmentId,
    userIdFromResult,
    {
      swr: {
        suspense: true,
      },
    }
  );

  const { data: categoriesData } = useGetStressAssessmentCategories(
    threeLetterCode,
    stressAssessmentId,
    {
      swr: {
        suspense: true,
      },
    }
  );

  return {
    result: resultData!,
    answers: answersData!,
    categories: categoriesData!,
    selectedTab,
    handleTabChange,
  };
};
